// Paletteカラーの型定義
export type PaletteColor =
  | "Blue"
  | "Skyblue"
  | "Lightgreen"
  | "Green"
  | "Orange"
  | "Red"
  | "Pink"
  | "Lavender"
  | "Purple"
  | "Gray";

// 各色の HEX 値を定義
export const PaletteColorHex: Record<PaletteColor, string> = {
  Blue: "#3989FA",
  Skyblue: "#69D5D8",
  Lightgreen: "#77C80A",
  Green: "#40C063",
  Orange: "#FCA733",
  Red: "#F85B52",
  Pink: "#FF80BD",
  Lavender: "#D67EF6",
  Purple: "#6C73E7",
  Gray: "#8A94A6",
};

// 各色の薄い背景色の HEX 値を定義
export const PaletteColorBg: Record<PaletteColor, string> = {
  Blue: "#EBF4FF",
  Skyblue: "#E9FBFC",
  Lightgreen: "#F1F9E7",
  Green: "#EDF9F0",
  Orange: "#FFF6EB",
  Red: "#FEF0EF",
  Pink: "#FFF2F8",
  Lavender: "#FBF2FE",
  Purple: "#F0F1FD",
  Gray: "#F3F4F6",
};

// ダークモード用の暗い背景色の HEX 値を定義
export const PaletteColorDarkBg: Record<PaletteColor, string> = {
  Blue: "#1e3a5f",
  Skyblue: "#1a4a4d",
  Lightgreen: "#2a3d1a",
  Green: "#1a3d26",
  Orange: "#4d3a1a",
  Red: "#4d1f1c",
  Pink: "#4d2639",
  Lavender: "#3d2647",
  Purple: "#2a2c4d",
  Gray: "#2d3340",
};

// ダークモード用のHex色（より明るく調整）
export const PaletteColorDarkHex: Record<PaletteColor, string> = {
  Blue: "#5BA0FC",
  Skyblue: "#8DE4E7",
  Lightgreen: "#9AD940",
  Green: "#5ED480",
  Orange: "#FDBE5C",
  Red: "#FA7D75",
  Pink: "#FF9FCE",
  Lavender: "#E09FF8",
  Purple: "#9198EE",
  Gray: "#A8B2C4",
};

// ダークモード対応: テキスト色を取得（ダークモード時はBg色、ライトモード時はHex色）
export const getTextColor = (
  color: PaletteColor,
  isDarkMode: boolean
): string => {
  return isDarkMode ? PaletteColorBg[color] : PaletteColorHex[color];
};

// ダークモード対応: 背景色を取得（ダークモード時はDarkBg色、ライトモード時はBg色）
export const getBgColor = (
  color: PaletteColor,
  isDarkMode: boolean
): string => {
  return isDarkMode ? PaletteColorDarkBg[color] : PaletteColorBg[color];
};

// ダークモード対応: アクセントカラーを取得（ダークモードでは明るめのDarkHex色）
export const getAccentColor = (
  color: PaletteColor,
  isDarkMode: boolean
): string => {
  return isDarkMode ? PaletteColorDarkHex[color] : PaletteColorHex[color];
};

// 現在のダークモード状態を取得するヘルパー
export const isDarkModeEnabled = (): boolean => {
  return document.documentElement.classList.contains("dark");
};
